import { useState, useEffect } from "react";
import { DailyProvider } from "@daily-co/daily-react";
import CallScreen from "./video_call/call_screen";

export default function VideoCallPage({ url, onJoin, onLeave }) {
    
    useEffect(() => {
        // Automatically join the call when component mounts
        if (onJoin) onJoin();
        
        // Cleanup when component unmounts
        return () => {
            if (onLeave) onLeave();
        };
    }, [onJoin, onLeave]);

    const handleEnd = async () => {
        if (onLeave) onLeave();
    }

    return (
        <div className="w-full h-full bg-gradient-to-b from-slate-950 via-fuchsia-950 to-gray-950 absolute inset-0 backdrop-blur-sm" style={{ zIndex: 50 }}>
            <DailyProvider>
                <CallScreen 
                    url={url} 
                    handleEnd={handleEnd} 
                />
            </DailyProvider>
        </div>
    );
}